import {ValueRetrieverBase} from "./Core/ValueRetrieverBase";
import {ComparisonTypeEnum} from "../../Fields/Core/ConditionOptions";

export class CheckboxValueRetriever extends ValueRetrieverBase{


    GetValue() {
        return this.Source.GetValue();
    }

    Compare(Comparison: ComparisonTypeEnum, Value: any) {

        if(!this.Source.GetIsVisible())
            return false;
        let selectedValue=this.GetValue();

        switch (Comparison) {
            case ComparisonTypeEnum.IsChecked:
                return selectedValue==true;
            case ComparisonTypeEnum.IsNotChecked:
                return selectedValue==false;

        }
    }



}